"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunicationSignalingClient = void 0;
var tstrouter_1 = require("@skype/tstrouter");
var TrouterUtils_1 = require("./TrouterUtils");
var TrouterSettings_1 = require("./TrouterSettings");
var constants_1 = require("./constants");
var CommunicationSignalingClient = /** @class */ (function () {
    function CommunicationSignalingClient(credential, logger, options) {
        this.credential = credential;
        this.logger = logger;
        this.options = options;
        this.stateChangedListener = null;
        this.tokenFetchRetries = 0;
        this.trouter = (0, tstrouter_1.createTrouterService)((0, TrouterUtils_1.toLogProvider)(logger));
    }
    CommunicationSignalingClient.prototype.start = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b;
            var _c;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.resourceEndpoint = ((_a = this.options) === null || _a === void 0 ? void 0 : _a.resourceEndpoint) || "";
                        if (!(this.config === undefined)) return [3 /*break*/, 2];
                        _b = this;
                        _c = {};
                        return [4 /*yield*/, (0, TrouterSettings_1.createSettings)(this.credential, this.options)];
                    case 1:
                        _b.config = (_c.trouterSettings = _d.sent(),
                            _c.skypeTokenProvider = function (forceRefresh) { return __awaiter(_this, void 0, void 0, function () {
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            if (!forceRefresh) return [3 /*break*/, 3];
                                            this.tokenFetchRetries += 1;
                                            if (!(this.tokenFetchRetries > constants_1.MAX_NUMBER_OF_TOKEN_FETCH_RETRIES)) return [3 /*break*/, 2];
                                            return [4 /*yield*/, this.stop(true)];
                                        case 1:
                                            _c.sent();
                                            throw new Error("Access token is expired and failed to fetch a valid one after ".concat(constants_1.MAX_NUMBER_OF_TOKEN_FETCH_RETRIES, " retries"));
                                        case 2: return [3 /*break*/, 4];
                                        case 3:
                                            this.tokenFetchRetries = 0;
                                            _c.label = 4;
                                        case 4:
                                            _b = (_a = Promise).resolve;
                                            return [4 /*yield*/, this.credential.getToken()];
                                        case 5: return [2 /*return*/, _b.apply(_a, [(_c.sent()).token])];
                                    }
                                });
                            }); },
                            _c.telemetryConfig = {
                                eventLogger: (0, TrouterUtils_1.toTelemetrySender)(this.logger),
                                settings: TrouterSettings_1.defaultTelemetrySettings
                            },
                            _c);
                        _d.label = 2;
                    case 2:
                        this.trouter.start(this.config);
                        this.trouter.setUserActivityState(tstrouter_1.UserActivityState.Active);
                        return [2 /*return*/];
                }
            });
        });
    };
    CommunicationSignalingClient.prototype.stop = function (isTokenExpired) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.trouter.offStateChanged(this.stateChangedListener);
                this.trouter.clearMessageHandlers();
                this.trouter.stop(isTokenExpired !== null && isTokenExpired !== void 0 ? isTokenExpired : this.tokenFetchRetries > constants_1.MAX_NUMBER_OF_TOKEN_FETCH_RETRIES);
                return [2 /*return*/];
            });
        });
    };
    CommunicationSignalingClient.prototype.on = function (event, listener) {
        if (event === "connectionChanged") {
            this.trouter.offStateChanged(this.stateChangedListener);
            this.stateChangedListener = function (state, _url) { return listener(state); };
            this.trouter.onStateChanged(this.stateChangedListener);
            return;
        }
        this.trouter.registerMessageHandler((0, TrouterUtils_1.toMessageHandler)(event, listener, this.resourceEndpoint));
    };
    return CommunicationSignalingClient;
}());
exports.CommunicationSignalingClient = CommunicationSignalingClient;
